import {GRAPH_COLORS} from '@/appLogic/appConstants/ColorSchema'
import {formatSmallMoney} from '@/helpers'

const incomeGraphData = function (income) {
  let data = income.map(d => d.value)
  // TODO we can add this to the charts to make them percentage central...
  let sum = data.reduce((acc, val) => acc + val)
  let percentages = data.map(d => (d / sum) * 100)
  // *****DONE******
  let labels = income.map(d => formatSmallMoney(String(d.startIncome)) +
    ' - ' + formatSmallMoney(String(d.finishIncome))
  )
  let label = 'Income Distribution'
  return {
    labels,
    datasets: [{
      label,
      data: percentages,
      backgroundColor: GRAPH_COLORS.DARK_BLUE,
      hoverBackgroundColor: GRAPH_COLORS.LIGHT_BLUE,
      borderColor: GRAPH_COLORS.BORDER_COLOR
    }]
  }
}

export {
  incomeGraphData
}



// WEBPACK FOOTER //
// ./src/app/appLogic/marketBreaks/IncomeMarketBreaks.js